import React from "react";
import { PageContainer } from "./PageElements";

const Page = ({ children }) => {
  return <PageContainer>{children}</PageContainer>;
};

export default Page;
